import axios, { CancelToken } from 'axios';

import { IContaSaldoDeContas } from '../../../../pages/SaldoDeContas/SolicitacoesDeAtivacao/interfaces';
import { IContaACadastrar } from '../../../../pages/SaldoDeContas/ContasACadastrar/interfaces';

import { GATEWAY_API_URL } from "../../../request/urls";
import { getToken } from "../../../token";

class ContasACadastrarService {
    async getQuantidadeContasACadastrar(): Promise<number> {

        const { data } = await axios.get(`${GATEWAY_API_URL}/saldo-empenhos/conta/qtde-a-cadastrar`, {
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
        });

        return data.quantidade_a_cadastrar;
    }

    async getContasACadastrar(signal?: CancelToken): Promise<IContaACadastrar[]> {

        const { data } = await axios.get(`${GATEWAY_API_URL}/saldo-empenhos/conta/a-cadastrar`, {
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
            cancelToken: signal
        });

        return data.contasACadastrar.map((conta: IContaACadastrar) => {
            return {
                ...conta,
                orgaoVinculado: {
                    ...conta.orgaoVinculado,
                    orgaoNome: conta.orgaoVinculado.orgao.nome,
                }
            }
        });
    }

    async createConta({
        orgaoVinculadoId,
        descricao,
        numero,
        agencia,
        bancoId,
        fonteIds,
    }: {
        orgaoVinculadoId: number,
        descricao: string,
        numero: string,
        agencia: string,
        bancoId: number,
        fonteIds: number[],
    }): Promise<IContaSaldoDeContas> {

        const { data } = await axios.post(
            `${GATEWAY_API_URL}/saldo-empenhos/conta`,
            {
                orgaoVinculadoId,
                descricao,
                numero,
                agencia,
                bancoId,
                fonteIds,
            },
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken()
                },
            }
        );

        return data;
    }

    async ignorarConta({
        numero,
        agencia,
        bancoId,
        orgaoVinculadoId,
    }: {
        numero: string;
        agencia: string;
        bancoId: number;
        orgaoVinculadoId: number;
    }): Promise<void> {
        await axios.post(
            `${GATEWAY_API_URL}/saldo-empenhos/conta/a-ignorar`,
            {
                numero,
                agencia,
                bancoId,
                orgaoVinculadoId,
            },
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken()
                },
            }
        );
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ContasACadastrarService();
